import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const AUTH_PATHS = [
  "/",
  "/login",
  "/reset-password",
  "/password-sent",
  "/register-phone",
  "/get-token",
];

const useClearLocalStorageOnClose = () => {
  const location = useLocation();

  useEffect(() => {
    const handleBeforeUnload = () => {
      const path = `${location.pathname}${location.search}`;
      const isAuthPath = AUTH_PATHS.includes(location.pathname);
      if (localStorage.getItem("token") && !isAuthPath) {
        sessionStorage.setItem("redirectAfterLogin", path);
      }
      localStorage.removeItem("token");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [location.pathname, location.search]);
};

export default useClearLocalStorageOnClose;
